import { FunctionComponent, ReactNode } from 'react';

import { useAutoScrollWhileDragging } from './useAuthScrollWhileDragging';
import { getScrollingElementClassName } from '@dw/pages/DashboardPage';

interface IDraggingAutoScrollContainerProps {
  children: ReactNode;
}
export const DraggingAutoScrollContainer: FunctionComponent<IDraggingAutoScrollContainerProps> = (props: IDraggingAutoScrollContainerProps) => {

  const { children } = props;

  useAutoScrollWhileDragging({
    threshold: 100,
    maxSpeed: 20,
    power: 1.8,
    horizontal: true,
    getScrollElement: () => document.getElementsByClassName(getScrollingElementClassName())[0] as HTMLElement
  })

  return children;
}